"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const types_1 = require("@kyruus/types");
const ProviderLogos_styles_1 = require("./ProviderLogos.styles");
const images_1 = require("../common/util/images");
const ProviderLogo_1 = __importDefault(require("./ProviderLogo"));
const ProviderLogos = ({ provider, logoConfigs = [], facets = [], logoSection = types_1.PMCLogoSections.SEARCH, isVertical = true }) => {
    /**
     * Method to turn a logo object into a LogoImage
     * @param {object} logo Object describing a logo
     * @return {JSX} LogoImage component for the passed in logo
     */
    const logoImageCreator = ({ logo_url: logoUrl, logo_name: logoName }) => {
        return (react_1.default.createElement(ProviderLogo_1.default, { key: `${logoUrl}:${logoName}`, url: logoUrl, affiliation: logoName }));
    };
    // Get the logos for the provider
    const logos = (0, images_1.getProviderLogoObjects)(provider, logoConfigs, facets, logoSection);
    return (react_1.default.createElement(ProviderLogos_styles_1.LogoList, { isVertical: isVertical }, logos.map(logoImageCreator)));
};
exports.default = ProviderLogos;
//# sourceMappingURL=ProviderLogos.js.map